import React, { createContext, useContext, useState } from "react";

const T = {
  en: { Home: "Home", About: "About", Businesses: "Businesses", Franchise: "Franchise", Investors: "Investors", Careers: "Careers", Contact: "Contact", apply: "Apply Now", login: "Login", dashboard: "Dashboard" },
  hi: { Home: "होम", About: "परिचय", Businesses: "व्यवसाय", Franchise: "फ्रैंचाइज़ी", Investors: "निवेशक", Careers: "करियर", Contact: "संपर्क", apply: "अभी आवेदन करें", login: "लॉगिन", dashboard: "डैशबोर्ड" },
};

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ld_lang") || "en");
  const toggle = () => setLang((l) => { const n = l === "en" ? "hi" : "en"; localStorage.setItem("ld_lang", n); return n; });
  const t = (key) => (T[lang] && T[lang][key]) || (T.en[key] ?? key);
  return <LanguageContext.Provider value={{ lang, toggle, t }}>{children}</LanguageContext.Provider>;
};
